module.exports = __webpack_public_path__ + "e8674801.svg";


//////////////////
// WEBPACK FOOTER
// ./src/logo.svg
// module id = 567
// module chunks = 0 1 2 3 4 5 6 7 8 9 10